import { FileDescriptor } from 'types/fileTypes';
import { PostType } from 'types/postTypes';

export const deleteUploadItem = (fileId: string, uploadFiles: FileDescriptor[]): FileDescriptor[] => {
  let updatedFiles: FileDescriptor[] = [];
  const index = uploadFiles.findIndex((file) => file.id === fileId);
  updatedFiles = uploadFiles.slice();
  updatedFiles.splice(index, 1);
  return updatedFiles;
};

export function updatePost(post: PostType): PostType {
  const reactionCount = post.meta.reaction_count ?? 0;
  const hasReacted = Boolean(post.myReaction);

  return {
    ...post,
    meta: {
      ...post.meta,
      reaction_count: hasReacted ? Math.max(0, reactionCount - 1) : reactionCount + 1,
    },
    myReaction: hasReacted ? undefined : '91:1',
  };
}
